import type { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

import { csvExport } from 'nextjs/getServerSideProps';
import PageNextJs from 'nextjs/PageNextJs';

import CsvExport from 'ui/pages/CsvExport';

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/csv-export">
      <CsvExport/>
    </PageNextJs>
  );
};

export default Page;

// export { csvExport as getServerSideProps } from 'nextjs/getServerSideProps';

export const getServerSideProps = async(context) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale, [ 'common' ])),
      ...(await csvExport(context)),
    },
  };
};
